/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";

/* components */
import { Scope } from "informed";
import GroupCollection from "../../../../shared/Forms/GroupCollection";

class Group extends Component {
	constructor(props) {
		super(props);
		this.state = {
			expanded: false,
		};
	}

	toggleGroup = () => {
		this.setState({ expanded: !this.state.expanded });
	};

	render() {
		const { property, propertyKey, collectionPrefix, renderProperties } = this.props;

		return (
			<div className="collection-group">
				<Scope scope={`${propertyKey}`}>
					<GroupCollection
						expanded={this.state.expanded}
						label={property.label}
						toggleGroup={this.toggleGroup}
					>
						{renderProperties(property.items.properties, `${collectionPrefix}.${propertyKey}`)}
					</GroupCollection>
				</Scope>
			</div>
		);
	}
}

Group.propTypes = {
	collectionPrefix: PropTypes.string,
	formApi: PropTypes.object,
	property: PropTypes.object,
	propertyKey: PropTypes.string,
	renderProperties: PropTypes.func,
};

export default Group;
